import { Fragment } from 'react';
import { Column, TableContainer, TableHeader, TableRow } from './SimpleTable';

interface TableSection<DataType extends Record<string, any>> {
  name: string;
  sectionData: DataType[];
}

export function SectionedTable<DataType extends Record<string, any>>(props: {
  sections: TableSection<DataType>[];
  columns: Column<DataType>[];
}) {
  return (
    <TableContainer>
      <TableHeader columns={props.columns} />
      <tbody className="divide-y divide-gray-200 bg-white">
        {props.sections.map((section, index) => (
          <Fragment key={section.name}>
            <tr className="border-t border-gray-200">
              <th
                colSpan={props.columns.length}
                scope="colgroup"
                className="bg-gray-50/25 py-3 text-left text-sm font-medium text-gray-900 pl-2"
              >
                {section.name}
              </th>
            </tr>
            <TableRow data={section.sectionData} columns={props.columns} />
          </Fragment>
        ))}
      </tbody>
    </TableContainer>
  );
}
